




















































import { Component, Vue } from 'vue-property-decorator';
import { regionServe, zyScreenServer } from '@/api/installServer';
import { arrayToTree } from '@/util/array';

@Component({
  components: {},
})
export default class DataBox6 extends Vue {
  private numForm: any = {
    risk_level_A: 0,
    risk_level_B: 0,
    risk_level_C: 0,
    risk_level_D: 0,
  };

  filterForm: any = {
    areaId: '',
  };
  spaceAreaList: any = []; // 区域下拉
  mounted() {
    const userInfo: any = JSON.parse((localStorage as any).getItem('userInfo'));
    this.filterForm.areaId = userInfo.areaId;
    this.getData();
    this.getSpaceAreaData();
  }
  // 区域列表
  getSpaceAreaData() {
    regionServe.getAreaAndSubAreaList({ areaId: this.filterForm.areaId }).then((res: any) => {
      if (res.code === '200') {
        this.spaceAreaList = arrayToTree(res.data);
      } else {
        this.$message.warning('获取区域的列表失败！');
      }
    });
  }
  areaChange() {
    this.getData();
  }
  getData() {
    zyScreenServer
      .getRiskManagementCountData({
        areaId: this.filterForm.areaId || null,
      })
      .then((res: any) => {
        this.numForm = res.data;
      })
      .catch((e: any) => {});
  }
  clickNum(type: any) {
    // this.$router.push({ name: 'DynamicRiskList', params: { riskLevel: type, history: 'false' } });
    this.$router.push({ name: 'RiskControlList', params: { riskLevel: type, areaId: this.filterForm.areaId, history: 'false' } });
  }
}
